import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions';

export interface SearchUsersParams {
  page: number;
  searchKey: string;
  search: string;
}

export interface SearchedUser {
  id: number;
  image: string;
  name: string;
  phone: string;
}

export interface SearchUsersResponse {
  data: SearchedUser[];
  meta: {
    current_page: number;
    last_page: number;
    total: number;
  };
}

export default (build: EndpointBuilder<any, any, any>) =>
  build.mutation<SearchUsersResponse, SearchUsersParams>({
    query: (body) => ({
      url: `v4/pitch-owner/users/search?page=${body.page}`,
      method: 'POST',
      body: {
        [body.searchKey]: body.search,
      },
    }),
  });
